export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyAy1ykNv8ReV5y0uyZk_IJ_rW2qUvxOd-g",
    authDomain: "kainero-fbde9.firebaseapp.com",
    projectId: "kainero-fbde9",
    storageBucket: "kainero-fbde9.appspot.com",
    messagingSenderId: "1075495192996",
    appId: "1:1075495192996:web:60e279e6f95029a0db1931",
    measurementId: "G-15LEQBPHQB"
};
